import { createSelector } from 'reselect';

// Selectors
import { selectSessionAgentAllowedTags } from 'app/modules/session/selectors';

// Utils
import getFullTagName from 'app/shared/utils/getFullTagName';

// Models
import { DropdownItemProps } from 'semantic-ui-react';
import { FullTagResponse } from 'app/modules/tags/responses';

export function selectAllTags(
  state: RootState,
  filterAllowedTags = false,
): Record<number, FullTagResponse> {
  const allTags = state.team.tags;
  if (filterAllowedTags) {
    const allowedTags = selectSessionAgentAllowedTags(state);
    return allowedTags.reduce((tags, allowedTag) => {
      if (Object.prototype.hasOwnProperty.call(allTags, allowedTag.id)) {
        return { ...tags, [allowedTag.id]: allowedTag };
      }
      return tags;
    }, {});
  }
  return allTags || {};
}

export const selectApiConfigAllowedEndpoints = (state: RootState) => {
  return state.team.api_config?.allowed_endpoints || [];
};

export const selectFormattedTags = createSelector(selectAllTags, (tags) => {
  // TODO use allowedTags ?
  const formattedTags: DropdownItemProps[] = Object.values(tags).map((tag) => {
    const fullTag = getFullTagName(tag.type, tag.name);
    return {
      key: tag.id,
      value: tag.id,
      text: fullTag,
      icon: 'tags',
    };
  });
  return formattedTags;
});
